import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course01 from "../../../course/course-01/course";
import lesson0124 from "../../course-01/lesson-24/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "0dddd49d-ac4a-4c67-9738-6abfd5b72959",
    course: {
      id: course01.id,
      slug: course01.slug as string,
      name: course01.name,
      publicId: course01.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course01, lesson0124),
    lesson: lesson0124,
  },
];

export default lessonLinks;
